import type { CrmPipelineResponse } from '../../../api';
import { SALES_STAGE_META } from './crmLabels';
import type { SalesStage } from '../../../api';

type Props = {
  pipeline: CrmPipelineResponse | null;
  onStageClick?: (stage: SalesStage) => void;
  hapticSelection: () => void;
};

export function CrmSalesFunnelBar({ pipeline, onStageClick, hapticSelection }: Props) {
  const stages = pipeline?.stages ?? (Object.keys(SALES_STAGE_META) as SalesStage[]);
  const counts = stages.map((s) => (pipeline?.columns[s] ?? []).length);
  const max = Math.max(...counts, 1);

  return (
    <div className="space-y-2">
      {stages.map((stage) => {
        const meta = SALES_STAGE_META[stage];
        const count = (pipeline?.columns[stage] ?? []).length;
        const width = (count / max) * 100;
        return (
          <button
            key={stage}
            type="button"
            onClick={() => {
              hapticSelection();
              onStageClick?.(stage);
            }}
            className="press w-full flex items-center gap-3 p-3 rounded-xl"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border-subtle)' }}
          >
            <div className="w-10 h-10 rounded-xl flex items-center justify-center shrink-0 text-xs font-black" style={{ background: meta.bg, color: meta.color }}>
              {count}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex justify-between mb-1">
                <span className="text-xs font-semibold" style={{ color: 'var(--text-2)' }}>
                  {meta.label}
                </span>
              </div>
              <div className="h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.1)' }}>
                <div className="h-full rounded-full" style={{ width: `${Math.max(width, 5)}%`, background: meta.color }} />
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
